"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clipboard = void 0;
require("core-js/modules/es.error.cause.js");
var _clipboard = _interopRequireDefault(require("clipboard"));
// Inspired by https://github.com/Inndy/vue-clipboard2

if (!_clipboard.default) {
  throw new Error('you should npm install `clipboard` --save at first ');
}
let successCallback;
let errorCallback;
let clipboardInstance;
const clipboard = exports.clipboard = {
  bind(el, binding) {
    if (binding.arg === 'success') {
      successCallback = binding.value;
    } else if (binding.arg === 'error') {
      errorCallback = binding.value;
    } else {
      clipboardInstance = new _clipboard.default(el, {
        text() {
          return binding.value;
        },
        action() {
          return binding.arg === 'cut' ? 'cut' : 'copy';
        }
      });
      clipboardInstance.on('success', e => {
        const callback = successCallback;
        callback && callback(e);
      });
      clipboardInstance.on('error', e => {
        const callback = errorCallback;
        callback && callback(e);
      });
    }
  },
  update(el, binding) {
    if (binding.arg === 'success') {
      successCallback = binding.value;
    } else if (binding.arg === 'error') {
      errorCallback = binding.value;
    } else {
      clipboardInstance = new _clipboard.default(el, {
        text() {
          return binding.value;
        },
        action() {
          return binding.arg === 'cut' ? 'cut' : 'copy';
        }
      });
    }
  },
  unbind(_, binding) {
    if (binding.arg === 'success') {
      successCallback = null;
    } else if (binding.arg === 'error') {
      errorCallback = null;
    } else {
      if (clipboardInstance) {
        clipboardInstance.destroy();
      }
      clipboardInstance = null;
    }
  }
};